
import {
	Vue,
	Component,
	Prop,
	PropSync,
	Watch,
	Inject
} from "vue-property-decorator";
import Header from "@/components/base/table/header/kunming/TitleHeader.vue";
import InformTable from "@/components/base/table/body/TableTextDecoration.vue";
import { Loading } from "element-ui";
import { Action, Getter, State } from "vuex-class";
import { deepClone, removeHTMLTag, getParentArea } from "@/common/utils";
import { pageViewUnit } from "@/config";
@Component({
	name: "Home",
	components: {
		Header, // text-header
		InformTable // text-table
	}
})
export default class Home extends Vue {
	@Action("policy/getPolicyList") private getPolicy: any;
	@Action("policy/getApplyList") private getApplyList: any;
	@Action("policy/getInformPolicy") private getInformPolicy: any;
	@State("directCityList") private directCityList: any;
	@Getter("cityName") private cityName: any;
	@Getter("provinceId") private provinceId: any;
	@Getter("cityId") private cityId: any;
	searchProjectBranchValue: any = "";
	searchProjectTitleValue: any = "";
	active = 0;
	btnList: Array<any> = [];
	tableData: any = [];
	loading = false;
	areaOption = this.$root.$data.areaOption;
	// tableData
	informData: any = [
		{
			title:
				"云南省人民政府关于印发云南省优化营商环境办法的通知（云政规〔2020〕1号）",
			date: "云南省人民政府"
		},
		{
			title:
				"中共云南省委办公厅云南省人民政府办公厅关于印发《云南省打造市场化法治化国际化一流营商环境实施方案》的通知（云办通〔2020〕31号）",
			date: "中共云南省委办公厅"
		},
		{
			title:
				"云南省人民政府办公厅关于全面推进基层政务公开标准化规范化工作的实施意见（云政办发〔2020〕33号）",
			date: "云南省人民政府办公厅"
		},
		{
			title:
				"云南省人民政府办公厅关于全面推进基层政务公开标准化规范化工作的实施意见（云政办发〔2020〕33号）",
			date: "云南省人民政府办公厅"
		},
		{
			title:
				"云南省人民政府办公厅关于应对新冠肺炎疫情影响进一步做好稳就业工作的若干意见（云政办发〔2020〕36号）",
			date: "云南省人民政府办公厅"
		},
		{
			title:
				"中共昆明市委办公室  昆明市人民政府办公室关于印发《昆明市全面提升一流营商环境工作方案》的通知（市委办〔2020〕39号）",
			date: "中共昆明市委办公室"
		},
		{
			title:
				"昆明市住房和城乡建设局关于印发《昆明市优化获得用气营商环境实施细则》的通知（昆建通〔2020〕219号）",
			date: "昆明市住房和城乡建设局"
		},
		{
			title:
				"昆明市人民政府金融办公室关于印发《昆明市优化提升获得信贷营商环境实施细则》的通知（昆金办〔2020〕77号）",
			date: "昆明市人民政府金融办办公室"
		},
		{
			title:
				"昆明市发展和改革委员会关于印发基本公共服务群众满意度指标优化提升营商环境实施细则的通知（昆发改社会〔2020〕402号）",
			date: "昆明市发展和改革委员会"
		},
		{
			title:
				"昆明市生态环境局关于印发蓝天碧水净土森林覆盖指数优化提升营商环境实施细则的通知（昆生环通〔2020〕73号）",
			date: "昆明市生态环境局"
		}
	];
	projectData: any = [
		{
			title: "昆明市进一步优化自来水接入营商环境改革实施办法（试行）",
			depart: "昆明市人民政府办公室"
		},
		{
			title: "昆明市进一步优化电力接入营商环境实施方案（试行）",
			depart: "昆明市人民政府办公室"
		},
		{
			title: "昆明市进一步优化燃气接入营商环境实施办法（试行）",
			depart: "昆明市人民政府办公室"
		},
		{
			title: "纳税指标优化提升营商环境实施细则",
			depart: "昆明市税务局"
		}
	];
	publicData: any = [
		{
			code: "KM202101081003",
			applyTime: "2021/1/8",
			state: "通过",
			dealTime: "2021/1/11"
		},
		{
			code: "KM202101081005",
			applyTime: "2021/1/8",
			state: "退回",
			dealTime: "2021/1/11"
		},
		{
			code: "KM202101301036",
			applyTime: "2021/1/30",
			state: "通过",
			dealTime: "2021/2/4"
		},
		{
			code: "KM202102081047",
			applyTime: "2021/2/8",
			state: "通过",
			dealTime: "2021/2/10"
		},
		{
			code: "KM202103111029",
			applyTime: "2021/3/11",
			state: "受理中",
			dealTime: "2021/3/12"
		}
	];
	newPublicyData: any = [];
	// loading
	loading_inform = false;
	loading_project = false;
	loading_public = false;
	created() {
		this.setData();
		this.getData();
	}
	tableRowClassName({ row, rowIndex }: any) {
		if (rowIndex % 2 === 1) {
			return "success-row";
		} else if (rowIndex % 2 === 0) {
			return "warning-row";
		}
		return "";
	}
	handleClickNone() {
		// alert('未定');
	}
	async setData() {
		if (this.directCityList.includes(this.cityId)) {
			this.btnList = [this.cityName, null, "全部"];
		} else {
			const provinceItem: any = getParentArea(this.areaOption, this.cityId);
			const provinceId = provinceItem ? provinceItem.value : provinceItem;
			this.btnList = [this.cityName, provinceId, "全部"];
		}
		this.btnList[0] = this.cityName;
	}
	/**
	 * ajax
	 */
	getData() {
		this.getInformList();
		this.getProjectList();
		this.getPublicyList();
	}
	// policy
	async getInformList() {
		// 0-city|1-国家|2-全部

		// this.loading_inform = true;
		// const options: any = {
		//   current: 1,
		//   size: 8,
		//   // addressCode: this.cityId,
		// };
		const provinceItem: any = getParentArea(this.areaOption, this.cityId);
		const provinceId = provinceItem.value;
		const allArea: any = [];
		const tempAreaOption = deepClone(this.areaOption);
		allArea.push(provinceId);
		allArea.push(String(this.cityId));
		const tempArea = tempAreaOption.filter((province: any) => {
			province.children = province.children
				.filter((city: any) => {
					const provinceItem: any = getParentArea(this.areaOption, city.value);
					const provinceId = provinceItem ? provinceItem.value : "";
					return city.value === this.cityId || provinceId === this.cityId;
				})
				.map((city: any) => {
					city.children.map((area: any) => {
						allArea.push(area.value);
						return area;
					});
					return city;
				});
			return province.value === provinceId;
		});

		const options: any = {
			current: 1,
			size: 5,
			addressCodeList: allArea
			// sort: "热度",
		};
		// this.getInformPolicy(options).then((res: any) => {
		//   const {code, data, msg} = res;

		//   if (code === 0) {
		//     const {records} = data;
		//     this.informData = records.map((policy: any) => {
		//       const {title, releaseDate: date, id} = policy;
		//       return {
		//         id,
		//         title,
		//         date,
		//       };
		//     });
		//     this.loading_inform = false;
		//     return records;
		//   }
		// });
	}

	async getProjectList() {
		const provinceItem: any = getParentArea(this.areaOption, this.cityId);
		const provinceId = provinceItem.value;
		const allArea: any = [];
		const tempAreaOption = deepClone(this.areaOption);
		allArea.push(provinceId);
		allArea.push(String(this.cityId));
		const tempArea = tempAreaOption.filter((province: any) => {
			province.children = province.children
				.filter((city: any) => {
					const provinceItem: any = getParentArea(this.areaOption, city.value);
					const provinceId = provinceItem ? provinceItem.value : "";
					return city.value === this.cityId || provinceId === this.cityId;
				})
				.map((city: any) => {
					city.children.map((area: any) => {
						allArea.push(area.value);
						return area;
					});
					return city;
				});
			return province.value === provinceId;
		});
		const options: any = {
			current: 1,
			size: 8,
			addressCodeList: allArea,
			// sort: "热度",
			dealTime: "申报中"
		};
	}
	async getPublicyList() {
		const provinceItem: any = getParentArea(this.areaOption, this.cityId);
		const provinceId = provinceItem.value;
		const allArea: any = [];
		const tempAreaOption = deepClone(this.areaOption);
		allArea.push(provinceId);
		allArea.push(String(this.cityId));
		const tempArea = tempAreaOption.filter((province: any) => {
			province.children = province.children
				.filter((city: any) => {
					const provinceItem: any = getParentArea(this.areaOption, city.value);
					const provinceId = provinceItem ? provinceItem.value : "";
					return city.value === this.cityId || provinceId === this.cityId;
				})
				.map((city: any) => {
					city.children.map((area: any) => {
						allArea.push(area.value);
						return area;
					});
					return city;
				});
			return province.value === provinceId;
		});
		const options: any = {
			current: 1,
			size: 5,
			addressCodeList: allArea,
			sort: "热度"
		};
		// this.loading_public = true;

		// this.getInformPolicy(options).then((res: any) => {
		//   this.loading_public = false;
		//   const {code, data, msg} = res;

		//   if (code === 0) {
		//     const {records} = data;
		//     this.publicData = records.map(({addressCode, content, releaseDate, department, id, title, deadline, pageView}: any) => {
		//       const release_date = new Date(releaseDate);
		//       const dead_date = new Date(deadline);
		//       const current_date = new Date();
		//       let dealTimer = 0;
		//       if(current_date.getTime()<release_date.getTime()) {
		//         dealTimer = 0;
		//         // not publish
		//       } else if(current_date.getTime()>dead_date.getTime()) {
		//         // deadline
		//         dealTimer = 2;
		//       } else {
		//         dealTimer = 1;
		//       }
		//       return {addressCode, content, releaseDate, department, id, title,dealTimer, pageView: pageView+pageViewUnit};
		//     });
		//     return records;
		//   }
		// });
	}
	async getNewPublicyList() {
		const provinceItem: any = getParentArea(this.areaOption, this.cityId);
		const provinceId = provinceItem.value;
		const allArea: any = [];
		const tempAreaOption = deepClone(this.areaOption);
		allArea.push(provinceId);
		allArea.push(String(this.cityId));
		const tempArea = tempAreaOption.filter((province: any) => {
			province.children = province.children
				.filter((city: any) => {
					const provinceItem: any = getParentArea(this.areaOption, city.value);
					const provinceId = provinceItem ? provinceItem.value : "";
					return city.value === this.cityId || provinceId === this.cityId;
				})
				.map((city: any) => {
					city.children.map((area: any) => {
						allArea.push(area.value);
						return area;
					});
					return city;
				});
			return province.value === provinceId;
		});
		const options: any = {
			current: 1,
			size: 2,
			addressCodeList: allArea,
			sort: "时间"
		};

		this.getInformPolicy(options).then((res: any) => {
			const { code, data, msg } = res;

			if (code === 0) {
				const { records } = data;
				this.newPublicyData = records.map(
					({
						addressCode,
						lead: htmlContent,
						releaseDate,
						department,
						id,
						title,
						deadline,
						pageView
					}: any) => {
						const release_date = new Date(releaseDate);
						const dead_date = new Date(deadline);
						const current_date = new Date();
						let dealTimer = 0;
						if (current_date.getTime() < release_date.getTime()) {
							dealTimer = 0;
							// not publish
						} else if (current_date.getTime() > dead_date.getTime()) {
							// deadline
							dealTimer = 2;
						} else {
							dealTimer = 1;
						}
						let content = "";
						if (htmlContent) {
							content = removeHTMLTag(htmlContent);
						}
						return {
							addressCode,
							content,
							releaseDate,
							department,
							id,
							title,
							dealTimer,
							pageView: pageView + pageViewUnit
						};
					}
				);
				return records;
			}
		});
	}
	/**
	 * handle click
	 */
	// policy
	clickPolicyLabel({ title, pubDate, id: policyId }: any) {
		this.$router.push({
			path: "/detail/policy",
			query: {
				policyId
			}
		});
	}
	clickPublicyLabel({ id: informId }: any) {
		// to Publicy detail
		this.$router.push({
			path: "/detail/inform",
			query: { informId }
		});
	}
	clickPolicyBtn(index: any) {
		this.active = index;
		// switch (index) {
		//   case 0: this.getPolicyList(0); break;
		//   case 1: this.getPolicyList(1); break;
		//   case 2: this.getPolicyList(2); break;
		//   default: this.getPolicyList(0);break;
		// }
	}
	clickPolicyMore() {
		this.$router.push({ path: "/pcm/policy" });
	}
	// project
	clickProjectLabel({ directionId, projectId }: any) {
		this.$router.push({
			path: "/detail/apply",
			query: {
				directionId,
				projectId
			}
		});
	}
	clickPublicyMore() {
		this.$router.push({
			path: "/pcm/inform"
		});
	}
	clickProjectMore() {
		this.$router.push({ path: "/pcm/apply" });
	}
	@Watch("cityName")
	handleCityChange(newValue: any, oldValue: any) {
		// const directCityList = ["北京市",  ];
		// const btnLength = this.btnList.length;
		// const tempArr = deepClone(this.btnList);
		// if(directCityList.includes(newValue)&&btnLength===3) {
		//   tempArr[1] = null;
		// }
		// tempArr[0] = newValue;
		// this.btnList = tempArr;
		this.setData();
		this.getData();
	}
}
